(function() {
    'use strict';

    angular.module("imApp").factory("bonusTypesOverviewService", ['$ihttp', function ($ihttp) {
        let call = function (method, parameters) {
            return $ihttp.post({
                method: method,
                parameters: parameters || {}
            });
        };

        let service = {
            getCustomersKeynameList: function (parameters) {
                //return call(-1, parameters || {});
                return [];
            },
            getOrdersKeynameList: function (parameters) {
                //return call(-1, parameters || {});
                return [];
            }
        };

        return service;
    }]);
})();
